<!--商品详情-->
<template>
  <div class="store-content">
    <!-- <m-header>
      <div slot="nav"></div>
    </m-header> -->
    <div class="w">
      <div class="gray-box">
        <div class="gallery-wrapper">
          <div class="gallery">
            <div class="thumb">
              <div class="big">
                <img :src="big" :alt="product.productName">
              </div>
            </div>
          </div>
        </div>
        <!--右边-->
        <div class="banner">
          <div class="sku-custom-title">
            <h4>{{product.productName}}</h4>
            <h6>
              <span>{{product.subTitle}}</span>
              <!-- <span class="price">
                <em>¥</em><i>{{product.salePrice.toFixed(2)}}</i></span> -->
            </h6>
          </div>
          <div class="num">
            <span class="params-name">数量</span>
            <buy-num @edit-num="editNum" :limit="Number(product.limitNum)"></buy-num>
          </div>
          <div class="buy">
            <y-button text="加入购物车"
              @btnClick="addCart(product.productId,product.salePrice,product.productName,product.productImageBig)"
              classStyle="main-btn" style="width: 145px;height: 50px;line-height: 48px"></y-button>
            <!-- <y-button text="现在购买" @btnClick="checkout(product.productId)"
              style="width: 145px;height: 50px;line-height: 48px;margin-left: 10px"></y-button> -->
          </div>
        </div>
      </div>
      <!--产品信息-->
      <div class="item-info gray-box">
        <div slot="content">
          <div class="img-item" v-if="productMsg">
            <div v-html="productMsg">{{ productMsg }}</div>
          </div>
          <div class="no-info" v-else>
            <img src="/static/images/no-data.png">
            <br>
            该商品暂无内容数据
          </div>
        </div>
      </div>
    </div>
    <!-- <m-footer></m-footer> -->
  </div>
</template>
<script>
  import goodsDetail from "/assets/config/goodsList.js";
  import MHeader from '/common/MHeader'
  import MFooter from '/common/MFooter'
  import {
    productDet,
    addCart
  } from '/api/goods'
  import {
    mapMutations,
    mapState
  } from 'vuex'
  import YShelf from '/components/YShelf'
  import BuyNum from '/components/buynum'
  import YButton from '/components/YButton'
  import {
    getStore
  } from '/utils/storage'
  export default {
    data() {
      return {
        productMsg: '',
        small: [],
        big: '',
        productNum: 1,
        userId: ''
      }
    },
    computed: {
      ...mapState(['user', 'cart'])
    },
    methods: {
      getGoodsDetail(productId) {
        let result = goodsDetail[productId]
        this.product = result
        this.productMsg = result.detail || ''
        this.small = result.productImageSmall
        this.big = result.productImageBig
      },
      addCart(id, price, name, img) {
        if (!this.cart.showMoveImg) { // 动画是否在运动
          if (this.user.isLogin) { // 登录了 直接存在用户名下
            addCart({
              userId: this.userId,
              productId: id,
              productNum: this.productNum
            }).then(res => {
              this.$store.commit('cart/addcart', {
                productId: id,
                salePrice: price,
                productName: name,
                productImg: img,
                productNum: this.productNum
              })
            })
          } else { // 未登录 vuex
            this.$store.commit('cart/addcart', {
              productId: id,
              salePrice: price,
              productName: name,
              productImg: img,
              productNum: this.productNum
            })
          }
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          // 需要触发
          this.$store.commit('cart/addanimation', {
            moveShow: true,
            elLeft: elLeft,
            elTop: elTop,
            img: img
          })
          if (!this.cart.showCart) {
            this.$store.commit('cart/showcart', {
              showCart: true
            })
          }
        }
      },
      checkout(productId) {
        // this.$router.push({
        //   path: '/checkout',
        //   query: {
        //     productId,
        //     num: this.productNum
        //   }
        // })
      },
      editNum(num) {
        this.productNum = num
      }
    },
    components: {
      YShelf,
      BuyNum,
      YButton,
      MHeader,
      MFooter
    },
    created() {
      let id = this.$route.query.productId
      this.getGoodsDetail(id)
      this.userId = getStore('userId')
      document.title = "医小智 - 产品详情"
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .store-content {
    // clear: both;
    // width: 1220px;
    // min-height: 600px;
    // padding: 0 0 25px;
    margin: 0 auto;
  }

  .gray-box {
    display: flex;
    // padding: 60px;
    margin: 10px 0;

    .gallery-wrapper {
      padding: 60px;

      .gallery {
        display: flex;
        width: 540px;

        .thumbnail {
          li:first-child {
            margin-top: 0px;
          }

          li {
            @include wh(80px);
            margin-top: 10px;
            padding: 12px;
            border: 1px solid #f0f0f0;
            border: 1px solid rgba(0, 0, 0, .06);
            border-radius: 5px;
            cursor: pointer;

            &.on {
              padding: 10px;
              border: 3px solid #ccc;
              border: 3px solid rgba(0, 0, 0, .2);
            }

            img {
              display: block;
              @include wh(100%);
            }
          }
        }

        .thumb {
          .big {
            margin-left: 120px;
          }

          img {
            display: block;
            @include wh(260px)
          }
        }
      }
    }

    // 右边
    .banner {
      padding: 60px 0;
      width: 450px;
      margin-left: 10px;

      h4 {
        font-size: 24px;
        line-height: 1.25;
        color: #000;
        margin-bottom: 13px;
      }

      h6 {
        font-size: 14px;
        line-height: 1.5;
        color: #bdbdbd;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .sku-custom-title {
        overflow: hidden;
        padding: 8px 8px 18px 10px;
        position: relative;
      }

      .params-name {
        padding-right: 20px;
        font-size: 14px;
        color: #8d8d8d;
        line-height: 36px;
      }

      .num {
        padding: 29px 0 8px 10px;
        border-top: 1px solid #ebebeb;
        display: flex;
        align-items: center;
      }

      .buy {
        position: relative;
        border-top: 1px solid #ebebeb;
        padding: 30px 0 0 10px;
      }
    }
  }

  .item-info {

    .gray-box {
      padding: 0;
      display: block;
    }

    .img-item {
      width: 1220px;
      text-align: center;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .no-info {
    padding: 200px 0;
    text-align: center;
    font-size: 30px;
  }

  .price {
    display: block;
    color: #d44d44;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-align: right;

    i {
      padding-left: 2px;
      font-size: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// goodsDetail.vue?069ca9de